import { FIRE_COOLDOWN } from '../game/combat'
import { clamp } from '../game/math'
import type { RacePhase, VehicleState } from '../game/types'
import { WEAPON_MOUNT } from '../game/weapon-mount'

export interface ShotPresentationPose {
  visible: boolean
  extension: number
  kick: number
  slide: number
  flash: number
}

type Point3 = [number, number, number]

interface WindowGunnerFrameInput {
  vehicle: Pick<VehicleState, 'weaponCooldown' | 'driverStunTimer'> | undefined
  paused: boolean
  phase: RacePhase
}

interface WindowGunnerLayout {
  recoilPivot: Point3
  flash: Point3
  gunner: Point3
  slide: Point3
  barrel: Point3
  sight: Point3
}

const HIDDEN_SHOT_POSE: ShotPresentationPose = {
  visible: false,
  extension: 0,
  kick: 0,
  slide: 0,
  flash: 0,
}

export const WINDOW_GUNNER_LAYOUT: WindowGunnerLayout = {
  recoilPivot: [...WEAPON_MOUNT.muzzle],
  flash: [...WEAPON_MOUNT.muzzle],
  gunner: [
    (WEAPON_MOUNT.window[0] - WEAPON_MOUNT.muzzle[0]) * 0.5,
    (WEAPON_MOUNT.window[1] - WEAPON_MOUNT.muzzle[1]) * 0.5,
    (WEAPON_MOUNT.window[2] - WEAPON_MOUNT.muzzle[2]) * 0.5,
  ],
  slide: [-0.07, 0.03, -0.34],
  barrel: [0, 0, -0.08],
  sight: [-0.02, 0.1, -0.28],
}

export function getShotPresentationPose(weaponCooldown: number): ShotPresentationPose {
  if (!Number.isFinite(weaponCooldown) || weaponCooldown <= 0 || weaponCooldown > FIRE_COOLDOWN) {
    return HIDDEN_SHOT_POSE
  }
  const phase = clamp(weaponCooldown / FIRE_COOLDOWN, 0, 1)
  const extensionPhase = clamp(phase / 0.45, 0, 1)
  return {
    visible: true,
    extension: extensionPhase * extensionPhase * (3 - 2 * extensionPhase),
    kick: clamp(weaponCooldown / 0.14, 0, 1),
    slide: Math.sin(phase * Math.PI * 0.5),
    flash: clamp((weaponCooldown - 0.13) / 0.05, 0, 1),
  }
}

export function getWindowGunnerFramePose({ vehicle, paused, phase }: WindowGunnerFrameInput): ShotPresentationPose {
  if (!vehicle || paused || vehicle.driverStunTimer > 0 || (phase !== 'racing' && phase !== 'finish-countdown')) {
    return HIDDEN_SHOT_POSE
  }
  return getShotPresentationPose(vehicle.weaponCooldown)
}
